<div class="flex justify-center mt-[32px]">
  <svg
    width="106"
    height="125"
    viewBox="0 0 106 125"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M105.805 117.058C105.805 121.112 77.976 124.398 51.048 124.398C24.12 124.398 2.29102 121.112 2.29102 117.058C2.29102 113.004 24.12 109.718 51.048 109.718C77.976 109.718 105.805 113.005 105.805 117.058Z"
      fill="#DFDFEB"
    />
    <path
      d="M91.547 44.4695L2.4248 69.2617L15.411 115.944L104.533 91.152L91.547 44.4695Z"
      fill="#00B0ED"
    />
    <path
      d="M2.4375 69.2507L37.9645 27.5827L91.7955 44.3887L2.4375 69.2507Z"
      fill="#00B0ED"
    />
    <path
      d="M75.7962 38.2216L9.13184 56.7664L17.714 87.6174L84.3784 69.0726L75.7962 38.2216Z"
      fill="#F2FBFF"
    />
    <path
      d="M53.5445 77.6397L15.4255 115.934L2.4375 69.2507L53.5445 77.6397Z"
      fill="#B7DFF4"
    />
    <path
      d="M52.3652 77.9677L104.783 91.0717L91.7952 44.3887L52.3652 77.9677Z"
      fill="#B7DFF4"
    />
    <path
      d="M83.7859 55.1607C90.3625 55.1607 95.6939 49.8293 95.6939 43.2527C95.6939 36.6761 90.3625 31.3447 83.7859 31.3447C77.2093 31.3447 71.8779 36.6761 71.8779 43.2527C71.8779 49.8293 77.2093 55.1607 83.7859 55.1607Z"
      fill="#FF6545"
    />
    <path
      d="M79.6592 46.3687H82.5492V40.6587H80.1122V38.8127C81.6782 38.5687 82.4442 38.2907 83.3502 37.7337H85.5432V46.3687H87.9122V48.7717H79.6592V46.3687Z"
      fill="white"
    />
    <path
      d="M7.18433 35.5073C7.18433 37.4373 5.61933 39.0023 3.68933 39.0023C1.75933 39.0023 0.194336 37.4373 0.194336 35.5073C0.194336 33.5773 1.75933 32.0123 3.68933 32.0123C5.61933 32.0123 7.18433 33.5773 7.18433 35.5073Z"
      fill="#B7DFF4"
    />
    <path
      d="M25.2729 6.83327L27.0659 0.602264L28.8599 6.83327L33.0029 8.62627L28.8599 10.4193L27.0659 16.6503L25.2729 10.4193L21.1299 8.62627L25.2729 6.83327Z"
      fill="#A4A7AE"
    />
    <path
      d="M49.4426 15.0964L50.4997 11.6023L51.5574 15.0964L54 16.102L51.5574 17.1082L50.4997 20.6023L49.4426 17.1082L47 16.102L49.4426 15.0964Z"
      fill="#125F7A"
    />
  </svg>
</div>
<p class="mt-[16px] text-center font-inter font-bold text-base xlplus:text-lg">
  Reset Link Sent
</p>
<p
  class="mt-[8px] font-lato font-normal text-center text-sm xlplus:text-base text-taxpod-gray-light"
>
  Check your inbox for the
  <span class="font-bold">Reset Password</span> link and complete the process
  within<span class="font-bold"> 48 hours </span>before it expires.
</p>
<p
  class="mt-[20px] font-lato font-normal text-center text-sm xlplus:text-base text-taxpod-gray-light"
>
  Didn’t receive the email?
</p>
<div class="mt-[16px] mx-[12px] text-center">
  <p-button
    (onClick)="sendResetLink()"
    [loading]="isSubmitting"
    [disabled]="isButtonDisabled()"
    styleClass="!px-[34px] xlplus:!px-[36px] !py-[10px] xlplus:!py-[12px] !bg-taxpod-blue !border-taxpod-blue disabled:!text-[#83858a] disabled:!bg-[#d5d7da] disabled:!border-[#d5d7da]"
    ><p class="font-lato font-bold text-sm xlplus:text-base">
      Resend It
    </p></p-button
  >
</div>
@if (isButtonDisabled()) {
<p
  class="mt-[8px] font-lato font-bold text-center text-xs xlplus:text-sm text-[#007DA9]"
>
  Retry in {{ countdown() }} seconds
</p>
}
<p
  class="flex justify-center items-center gap-2 mt-[28px] mb-[12px] font-lato font-bold text-center text-sm xlplus:text-base cursor-pointer text-taxpod-blue"
  routerLink="/auth/login"
>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.04754 13.0623L7.35387 13.774C7.06015 14.0753 6.5852 14.0753 6.29461 13.774L0.220288 7.545C-0.0734293 7.24365 -0.0734293 6.75636 0.220288 6.45821L6.29461 0.226013C6.58833 -0.0753378 7.06327 -0.0753378 7.35387 0.226013L8.04754 0.937715C8.34438 1.24227 8.33813 1.73918 8.03504 2.03733L4.26984 5.71766H13.2501C13.6657 5.71766 14 6.06068 14 6.48706V7.51294C14 7.93932 13.6657 8.28235 13.2501 8.28235H4.26984L8.03504 11.9627C8.34126 12.2608 8.34751 12.7577 8.04754 13.0623Z"
      fill="#00B0ED"
    />
  </svg>
  Back to Login
</p>
